import type { TextFieldProps } from '@mui/material';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Input = styled((props: TextFieldProps) => {
  return (
    <TextField
      InputLabelProps={{
        sx: {
          transform: props.value
            ? 'translate(12px, -7px) scale(0.75)'
            : 'translate(16px, 10px) scale(1)',
          fontSize: '0.875rem',

          '&.Mui-focused, &.MuiFormLabel-filled': {
            transform: 'translate(12px, -7px) scale(0.75)',
          },
        },
      }}
      fullWidth
      size="small"
      {...props}
    />
  );
})(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius * 2,
  },

  '& .MuiInputBase-input': {
    padding: `${theme.spacing(1.25)} ${theme.spacing(2)}`,
    fontSize: '0.875rem',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    '& legend': {
      fontSize: '0.625rem',
    },
  },
}));
